import { z } from 'zod'

import { entitySchema, nanoidSchema } from '@/utility'

export const identityProviders = [
  'local',
  'google',
  'okta',
  'auth0',
  'azure',
  'one-login',
  'ping-identity',
] as const

export type IdentityProviders = (typeof identityProviders)[number]

export const IdpLabels: Record<IdentityProviders, string> = {
  'google': 'Google',
  'local': 'Local',
  'okta': 'Okta',
  'auth0': 'Auth0',
  'azure': 'Azure',
  'one-login': 'OneLogin',
  'ping-identity': 'Ping Identity',
} as const

export const identityProviderRecordSchema = entitySchema
  .extend({
    uid: nanoidSchema,
    name: z.string(),
    provider: z.enum(identityProviders),
    createUsers: z.boolean().default(false),
    signRequests: z.boolean().default(false),
    /** Initiation URL */
    ssoUrl: z
      .string()
      .default('')
      .describe('This URL is used by Scalar to initiate a SAML login.'),
    /** IdP issuer */
    issuer: z
      .string()
      .default('')
      .describe(
        'This is the URI that identifies your SAML identity provider. Any assertions must use a matching <saml:Issuer> attribute.',
      ),
    /** Public provider certificate */
    x509Cert: z
      .string()
      .default('')
      .describe(
        'The authentication certificate issued by your identity provider',
      ),
    /** Allow hosting authentication only */
    consumerOnly: z.boolean(),
  })
  .meta({ id: 'identity-provider-record' })

export type IdentityProviderRecord = z.infer<
  typeof identityProviderRecordSchema
>
